import { Environment } from './enviroment.model';

export const environment: Environment = {
    production: true,
    apiURL: 'https://test.login.hippodata.de/api/',
    loginInitials: '',
    loginPassword: '',
    isTestSystem: true,
    cognito: {
        authority:
            'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_qArvNDcKj',
        clientId: '2jmj5n12uf5av6o4kbkelhmi1e',
        redirectUrl: 'https://test.login.hippodata.de',
        postLogoutRedirectUri: 'https://test.login.hippodata.de',
        scope: 'email openid phone',
        responseType: 'code',
        hostedUiDomain: 'https://auth.longinesid.net',
    },
};
